import type { OtherCostKeys } from "../shapes/ShapeOtherCostsGroup.js";
import type { AppraisalDocumentFacade } from "./AppraisalDocumentFacade.js";
import type { WithRelativesSetDelegate } from "./delegates/WithRelativesSetDelegate.js";
import type { OtherCostsGroupFacade } from "./OtherCostsGroupFacade.js";
import {
  readOnlyRelativesSetFacadeWithAbsolute,
  type RelativesSetFacade,
} from "./RelativesSetFacade.js";

export type OtherCostsGroupRelativesFacade = RelativesSetFacade<
  OtherCostKeys,
  WithRelativesSetDelegate<OtherCostKeys>
>;

/**
 * Creates a decorator for the costs totals using read-only relatives.
 *
 * This store is left here so that we are not tempted to use it in the other parts
 * of the app to derive calculation. It proved itself to be generating loops and hard
 * to debug issues.
 */
export const createOtherCostsGroupRelatives = (
  otherCostGroup: OtherCostsGroupFacade,
  appraisal: AppraisalDocumentFacade,
): OtherCostsGroupRelativesFacade =>
  readOnlyRelativesSetFacadeWithAbsolute(
    {
      relatives: {
        absolute: otherCostGroup.costsTotal?.toFraction() ?? null,
        ratioBuildCostGlobalTotal: null,
        ratioGdv: null,
      },
    },
    {
      ratioBuildCostGlobalTotal: () =>
        appraisal.stages.build.buildCostGlobalTotal,
      ratioGdv: () => appraisal.stages.revenue.getGrossDevelopmentValue("any"),
    },
  );
